"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/web.dom.iterable");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _treater = require("@/api/treater");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _region = require("@/api/region");
var _org = require("@/api/org");
var _utils = require("@/utils");
var _vueTreeselect = _interopRequireDefault(require("@riophae/vue-treeselect"));
require("@riophae/vue-treeselect/dist/vue-treeselect.css");
var _user = require("@/api/user");
var _config_diseaseclass = require("@/api/config_diseaseclass");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import CardViewItem from './components/CardViewItem'

// secondary package based on el-pagination

var defaultTreater = {
  // id: '',
  real_name: '',
  treatername: '',
  dept: null,
  mobile: '',
  sex: '',
  // 1 未知  2 男  3 女
  addrs: '',
  birthdate: null,
  recommender: null,
  treater_type: 1,
  // 1 普通TTS操作师 2 总TTS操作师
  province_code: '',
  city_code: '',
  district_code: '',
  zip_code: '',
  accounts_name: '',
  accounts_no: '',
  disease_class: null
};
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default,
    Treeselect: _vueTreeselect.default
  },
  data: function data() {
    return {
      listLoading: false,
      listQuery: {
        page: 1,
        page_size: 20,
        status: 3 // 1 正常 2 禁用 3 待审核
      },
      doctorList: {
        count: 0
      },
      multipleSelection: [],
      dialogVisible: false,
      treater: defaultTreater,
      rule1: {
        real_name: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }],
        treatername: [{
          required: true,
          message: '请输入账号',
          trigger: 'change'
        }],
        dept: [{
          required: true,
          message: '请选择所属部门',
          trigger: 'blur'
        }],
        sex: [{
          required: true,
          message: '请选择性别',
          trigger: 'change'
        }],
        mobile: [{
          required: true,
          message: '请选择手机号码',
          trigger: 'blur'
        }],
        disease_class: [{
          required: true,
          message: '请选择科室',
          trigger: 'change'
        }]
      },
      sexOptions: [{
        key: 2,
        display_name: '男'
      }, {
        key: 3,
        display_name: '女'
      }],
      treaterTypeOptions: [{
        key: 1,
        display_name: '普通TTS操作师'
      }, {
        key: 2,
        display_name: '总TTS操作师'
      }],
      orgData: [],
      provinceData: [],
      cityData: [],
      defaultCity: [],
      districtData: [],
      defaultDistrict: [],
      orgData1: [],
      options: []
    };
  },
  created: function created() {
    this.getList();
    this.getProvinceAll();
    this.getCityAll();
    this.getDistrictAll();
    this.getOrgAll();
    this.getOrg();
    this.getDiseaseclass();
  },
  methods: {
    checkPermission: _permission.default,
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _treater.getTreaterList)(this.listQuery).then(function (response) {
        if (response.data) {
          _this.doctorList = response.data;
        }
        _this.listLoading = false;
      });
    },
    resetFilter: function resetFilter() {
      this.listQuery = {
        page: 1,
        page_size: 20,
        doctor_type: 1,
        status: 3
      };
      this.getList();
      this.$refs.multipleTable.clearSelection();
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      // console.log('111', this.multipleSelection)
    },
    requestPromise: function requestPromise(data) {
      return new Promise(function (resolve, reject) {
        (0, _treater.updateTreater)(data.id, data).then(function (res) {
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    handleSign: function handleSign() {
      var _this2 = this;
      this.listLoading = true;
      return new Promise(function (resolve, reject) {
        return Promise.allSettled(_this2.multipleSelection.map(function (item) {
          return _this2.requestPromise({
            id: item.id,
            status: 1
          });
        })).then(function (result) {
          _this2.listLoading = false;
          resolve();
          var successCount = result.filter(function (item) {
            return item.status === 'fulfilled';
          }).length;
          var failCount = result.filter(function (item) {
            return item.status === 'rejected';
          }).length;
          if (successCount) {
            _this2.$message({
              message: "\u6210\u529F\u5BA1\u6838".concat(successCount, "\u4F4DTTS\u64CD\u4F5C\u5E08"),
              type: 'success'
            });
          }
          if (failCount) {
            _this2.$message({
              message: "".concat(failCount, "\u4F4DTTS\u64CD\u4F5C\u5E08 \u5BA1\u6838\u5931\u8D25"),
              type: 'error'
            });
          }
          _this2.resetFilter();
        }).catch(function (error) {
          _this2.listLoading = false;
          reject(error);
          _this2.resetFilter();
        });
      });
    },
    handleEdit: function handleEdit(scope) {
      var _this3 = this;
      this.treater = Object.assign({}, scope.row); // copy obj
      this.cityData = [];
      if (this.treater.province_code) {
        var province_code = this.provinceData.filter(function (item) {
          return item.id === _this3.treater.province_code;
        })[0].province_code;
        this.defaultCity.forEach(function (item) {
          if (item.province_code === province_code) {
            var item_city = Object.assign({}, item);
            _this3.cityData.push(item_city);
          }
        });
      }
      this.districtData = [];
      if (this.treater.city_code) {
        var city_code = this.cityData.filter(function (item) {
          return item.id === _this3.treater.city_code;
        })[0].city_code;
        this.defaultDistrict.forEach(function (item) {
          if (item.city_code === city_code) {
            var item_district = Object.assign({}, item);
            _this3.districtData.push(item_district);
          }
        });
      }
      this.dialogType = 'edit';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this3.$refs['Form'].clearValidate();
      });
    },
    getProvinceAll: function getProvinceAll() {
      var _this4 = this;
      (0, _region.getProvinceAll)().then(function (response) {
        _this4.provinceData = response.data;
      });
    },
    provinceChange: function provinceChange(val) {
      var _this5 = this;
      this.cityData = [];
      this.treater.city_code = '';
      this.treater.district_code = '';
      this.defaultCity.forEach(function (item) {
        var item_city = Object.assign({}, item);
        _this5.cityData.push(item_city);
      });
      var province_code = this.provinceData.filter(function (item) {
        return item.id === val;
      })[0].province_code;
      this.cityData = this.cityData.filter(function (item) {
        return item.province_code === province_code;
      });
    },
    getCityAll: function getCityAll() {
      var _this6 = this;
      (0, _region.getCityAll)().then(function (response) {
        _this6.defaultCity = response.data;
        _this6.cityData = [];
        _this6.defaultCity.forEach(function (item) {
          var item_city = Object.assign({}, item);
          _this6.cityData.push(item_city);
        });
      });
    },
    cityChange: function cityChange(val) {
      var _this7 = this;
      this.districtData = [];
      this.treater.district_code = '';
      this.defaultDistrict.forEach(function (item) {
        var item_district = Object.assign({}, item);
        _this7.districtData.push(item_district);
      });
      var city_code = this.cityData.filter(function (item) {
        return item.id === val;
      })[0].city_code;
      this.districtData = this.districtData.filter(function (item) {
        return item.city_code === city_code;
      });
    },
    getDistrictAll: function getDistrictAll() {
      var _this8 = this;
      (0, _region.getDistrictAll)().then(function (response) {
        _this8.defaultDistrict = response.data;
        _this8.districtData = [];
        _this8.defaultDistrict.forEach(function (item) {
          var item_district = Object.assign({}, item);
          _this8.districtData.push(item_district);
        });
      });
    },
    getOrgAll: function getOrgAll() {
      var _this9 = this;
      (0, _org.getOrgAll)().then(function (response) {
        _this9.orgData_origin = response.data;
        _this9.orgData = (0, _utils.genTree)(response.data);
      });
    },
    getOrg: function getOrg() {
      var _this10 = this;
      (0, _org.getDoctorOrg)({
        commission_id: 4
      }).then(function (response) {
        _this10.orgData1 = (0, _utils.genTree)(response.data);
      });
    },
    getDiseaseclass: function getDiseaseclass() {
      var _this11 = this;
      (0, _config_diseaseclass.getDiseaseClassAll)().then(function (response) {
        _this11.options = response.data;
      });
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(form) {
        var _this12 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  _this12.treater.status = 1;
                  (0, _treater.updateTreater)(_this12.treater.id, _this12.treater).then(function (res) {
                    console.log(res);
                    _this12.getList();
                    _this12.dialogVisible = false;
                    _this12.$message({
                      message: '审核成功',
                      type: 'success'
                    });
                  }).catch(function (error) {
                    console.log(2, error);
                    _this12.$message({
                      message: '审核失败',
                      type: 'error'
                    });
                  });
                }
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function confirm(_x) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }()
  }
};